import React from 'react'
import ReactTooltip from 'react-tooltip'
import styles from './styles.module.css'

const Tooltip = ({ id, content, children, tooltipProps }) => {
  return (
    <>
      <div className={styles.tooltipContainer} data-tip={content} data-for={id}>
        {children}
        <ReactTooltip id={id} multiline effect="solid" place="right" {...tooltipProps} />
      </div>
    </>
  )
}

export default Tooltip
